import React from "react";
import Chat from "./components/Chat";
import "./App.css";

function App() {
  return (
    <div>
      <Chat
        API_URL={window.zChatBot.API_URL}
        TOKEN={window.zChatBot.TOKEN}
        USECASE={window.zChatBot.USECASE}
        INPUT_PLACEHOLDER={window.zChatBot.INPUT_PLACEHOLDER}
        BOX_TITLE={window.zChatBot.BOX_TITLE}
        TEXT_INTRO={window.zChatBot.TEXT_INTRO}
        TEXT_SLIDE_1={window.zChatBot.TEXT_SLIDE_1}
        TEXT_SHORTCODE={window.zChatBot.TEXT_SHORTCODE}
      />
    </div>
  );
}

export default App;
